import React, { useEffect, useRef, useState } from "react";
import useCart from "hooks/useCart";
import LocalOfferBlockNotEligible from "./LocalOfferBlockNotEligible";
import {
  getClientLocalCatalogs,
  getFilterActivation,
  resetEligibility,
} from "../localOfferEligibility/LocalOfferEligibility";
import { pushLocalOfferFilter } from "lib/gtm";
import { Hidden, useMediaQuery, useTheme } from "@material-ui/core";
import { scrollToRef } from "components/utils";
import LocalOfferBlockDefaultMobile from "../design-system/organisms/LocalOfferBlockDefaultMobile/LocalOfferBlockDefaultMobile";
import LocalOfferTurquoiseBlock from "./LocalOfferTurquoiseBlock";

export default function LocalOfferBlock({
  addCatalogsToRefinementList,
  removeCatalogsFromRefinementList,
  searchResults,
}) {
  const [cart, dispatch] = useCart();
  const [clientCatalogs, setClientCatalogs] = useState(undefined);
  const [autoFocusField, setAutoFocusField] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  const refineCatalogs = () => {
    setClientCatalogs(getClientLocalCatalogs());
    addCatalogsToRefinementList();
  };

  useEffect(() => {
    if (!cart.shipping.address.zipcode) {
      resetEligibility();
    } else if (!clientCatalogs && getFilterActivation()) {
      refineCatalogs();
    }
    if (clientCatalogs && clientCatalogs.length > 0) {
      pushLocalOfferFilter(cart.shipping.address.zipcode, true);
      isMobile && scrollToRef(EligibleRef);
    }
    if (clientCatalogs && clientCatalogs.length === 0) {
      isMobile && scrollToRef(NotEligibleRef);
      pushLocalOfferFilter(cart.shipping.address.zipcode, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart.shipping.address.zipcode, clientCatalogs, isMobile]);

  const NotEligibleRef = useRef();
  const EligibleRef = useRef();

  const handleResetAddress = () => {
    resetEligibility();
    setAutoFocusField(true);
    dispatch({
      type: "updateShipping",
      shipping: {
        address: {},
      },
    });
    setClientCatalogs(undefined);
    removeCatalogsFromRefinementList();
  };

  const renderDesktopBlock = () => {
    if (cart.shipping.address.zipcode && clientCatalogs) {
      if (clientCatalogs.length === 0) {
        return (
          <div ref={NotEligibleRef}>
            <Hidden smDown implementation="css">
              <LocalOfferBlockNotEligible
                numberOfProductsAvailable={searchResults?.nbHits}
                handleResetAddress={handleResetAddress}
              />
            </Hidden>
          </div>
        );
      } else {
        return (
          <div ref={EligibleRef}>
            <Hidden smDown implementation="css">
              <LocalOfferTurquoiseBlock autoFocusField={autoFocusField} addCatalogsToRefinementList={refineCatalogs} />
            </Hidden>
          </div>
        );
      }
    } else {
      return <LocalOfferTurquoiseBlock autoFocusField={autoFocusField} addCatalogsToRefinementList={refineCatalogs} />;
    }
  };

  return (
    <>
      {!(getClientLocalCatalogs()?.length > 0) && (
        <Hidden mdUp implementation="css">
          <LocalOfferBlockDefaultMobile addCatalogsToRefinementList={refineCatalogs} />
        </Hidden>
      )}
      <Hidden smDown implementation="css">
        {renderDesktopBlock()}
      </Hidden>
    </>
  );
}
